import { useParams } from "react-router-dom";

const blogData = {
    "child-health": {
        title: "Child Health – बच्चों की सेहत और सही विकास",
        image: "/images/blogs/1.jpg",
        content: {
            intro: `बच्चों का स्वास्थ्य उनके शारीरिक, मानसिक और सामाजिक विकास की नींव होता है।
जन्म से लेकर किशोरावस्था तक सही देखभाल, पोषण और समय पर इलाज से बच्चा
स्वस्थ, सक्रिय और आत्मविश्वासी बनता है।`,

            nutrition: [
                "माँ का दूध – पहले 6 महीनों तक सबसे उत्तम आहार",
                "प्रोटीन – दाल, अंडा, दूध, दही",
                "आयरन – हरी सब्ज़ियाँ, गुड़, चुकंदर",
                "कैल्शियम – दूध, पनीर, दही",
                "फल और सब्ज़ियाँ – रोग प्रतिरोधक क्षमता बढ़ाने के लिए",
            ],

            vaccination: `बच्चों को पोलियो, खसरा, टीबी, डिप्थीरिया, काली खांसी जैसी
गंभीर बीमारियों से बचाने के लिए समय पर टीकाकरण अत्यंत आवश्यक है।
राष्ट्रीय टीकाकरण कार्यक्रम के अनुसार सभी टीके लगवाना चाहिए।`,

            mental: `बच्चों के मानसिक विकास के लिए सकारात्मक वातावरण बहुत जरूरी है।
माता-पिता का प्यार, बातचीत और खेल-कूद बच्चे के आत्मविश्वास को बढ़ाता है।`,

            checkup: [
                "वजन और लंबाई की निगरानी",
                "आँख और कान की जांच",
                "दाँतों की देखभाल",
                "बार-बार बीमार होने पर डॉक्टर से सलाह",
            ],

            prevention: [
                "स्वच्छता की आदतें सिखाएँ",
                "हाथ धोने की आदत",
                "पौष्टिक भोजन और पर्याप्त नींद",
            ],
        },
    },

    "women-health": {
        title: "Women Health – महिलाओं के स्वास्थ्य की पूरी जानकारी",
        image: "/images/blogs/2.jpg",
        content: {
            intro: `महिलाओं का स्वास्थ्य पूरे परिवार की सेहत की नींव होता है।
    हार्मोन संतुलन, पोषण और नियमित जांच से महिलाएँ स्वस्थ जीवन जी सकती हैं।`,

            nutrition: [
                "आयरन युक्त आहार – एनीमिया से बचाव",
                "कैल्शियम – हड्डियों की मजबूती",
                "प्रोटीन – शरीर की ऊर्जा",
            ],

            vaccination: `महिलाओं को गर्भावस्था से पहले और बाद में
    आवश्यक टीके लगवाना चाहिए ताकि माँ और बच्चा सुरक्षित रहें।`,

            mental: `मानसिक तनाव, हार्मोन बदलाव और पारिवारिक जिम्मेदारियों
    के कारण महिलाओं को भावनात्मक सहयोग बहुत जरूरी है।`,

            checkup: [
                "हीमोग्लोबिन जांच",
                "ब्लड प्रेशर",
                "हार्मोन जांच",
                "गायनेकोलॉजिस्ट से परामर्श",
            ],

            prevention: [
                "संतुलित आहार",
                "नियमित व्यायाम",
                "पर्याप्त नींद",
            ],
        },
    },
    "diabetes-care": {
        title: "Diabetes Care – मधुमेह को कैसे नियंत्रित करें",
        image: "/images/blogs/3.jpg",
        content: {
            intro: `डायबिटीज एक साइलेंट बीमारी है लेकिन सही जीवनशैली से
    इसे पूरी तरह नियंत्रित किया जा सकता है।`,

            nutrition: [
                "कम शुगर वाला आहार",
                "फाइबर युक्त भोजन",
                "तेल और मिठाई सीमित करें",
            ],

            vaccination: `डायबिटीज मरीजों को संक्रमण से बचाव के लिए
    समय पर टीकाकरण करवाना चाहिए।`,

            mental: `लंबे समय तक चलने वाली बीमारी के कारण
    मानसिक तनाव से बचना जरूरी है।`,

            checkup: [
                "ब्लड शुगर जांच",
                "HbA1c टेस्ट",
                "आँख और किडनी जांच",
            ],

            prevention: [
                "नियमित वॉक",
                "वजन नियंत्रण",
                "दवाइयों का सही सेवन",
            ],
        },
    },
    "heart-health": {
        title: "Heart Health – दिल को स्वस्थ कैसे रखें",
        image: "/images/blogs/4.jpg",
        content: {
            intro: `दिल हमारे शरीर का सबसे महत्वपूर्ण अंग है।
    स्वस्थ दिल के लिए जीवनशैली में सुधार जरूरी है।`,

            nutrition: [
                "कम नमक वाला भोजन",
                "हरी सब्ज़ियाँ और फल",
                "ओमेगा-3 युक्त आहार",
            ],

            vaccination: `दिल के मरीजों को फ्लू और अन्य संक्रमण
    से बचाव के लिए टीकाकरण जरूरी है।`,

            mental: `तनाव दिल की बीमारियों का मुख्य कारण है,
    इसलिए मानसिक शांति आवश्यक है।`,

            checkup: [
                "ब्लड प्रेशर",
                "ईसीजी",
                "कोलेस्ट्रॉल जांच",
            ],

            prevention: [
                "धूम्रपान से दूरी",
                "नियमित व्यायाम",
                "तनाव नियंत्रण",
            ],
        },
    },
    "bone-joint-care": {
        title: "Bone & Joint Care – हड्डियों और जोड़ों की देखभाल",
        image: "/images/blogs/5.jpg",
        content: {
            intro: `हड्डियाँ और जोड़ शरीर को मजबूती और गति प्रदान करते हैं।
    उम्र बढ़ने, कैल्शियम की कमी और गलत जीवनशैली से जोड़ों की समस्याएँ हो सकती हैं।`,

            nutrition: [
                "कैल्शियम युक्त आहार – दूध, दही, पनीर",
                "विटामिन D – धूप और सप्लीमेंट",
                "प्रोटीन – हड्डियों की मरम्मत के लिए",
            ],

            vaccination: `कुछ संक्रमण हड्डियों और जोड़ों को प्रभावित कर सकते हैं,
    इसलिए डॉक्टर की सलाह अनुसार टीकाकरण जरूरी है।`,

            mental: `लगातार दर्द के कारण मानसिक तनाव बढ़ सकता है,
    इसलिए सकारात्मक सोच और धैर्य जरूरी है।`,

            checkup: [
                "हड्डियों की घनत्व जांच (BMD)",
                "एक्स-रे",
                "विटामिन D और कैल्शियम जांच",
            ],

            prevention: [
                "नियमित हल्का व्यायाम",
                "वजन नियंत्रण",
                "गलत बैठने की आदत से बचें",
            ],
        },
    },
    "pregnancy-care": {
        title: "Pregnancy Care – गर्भावस्था में जरूरी सावधानियां",
        image: "/images/blogs/6.jpg",
        content: {
            intro: `गर्भावस्था एक संवेदनशील और महत्वपूर्ण समय होता है।
    माँ और बच्चे दोनों की सेहत का ध्यान रखना अत्यंत आवश्यक है।`,

            nutrition: [
                "आयरन और फोलिक एसिड",
                "कैल्शियम – हड्डियों के विकास के लिए",
                "प्रोटीन और ताजे फल",
            ],

            vaccination: `टिटनेस और अन्य आवश्यक टीके
    माँ और बच्चे दोनों को सुरक्षित रखते हैं।`,

            mental: `हार्मोन बदलाव के कारण भावनात्मक उतार-चढ़ाव सामान्य है,
    परिवार का सहयोग बहुत जरूरी है।`,

            checkup: [
                "नियमित ANC जांच",
                "अल्ट्रासाउंड",
                "ब्लड प्रेशर और शुगर जांच",
            ],

            prevention: [
                "पर्याप्त आराम",
                "डॉक्टर की सलाह अनुसार दवाइयाँ",
                "भारी काम से बचें",
            ],
        },
    },
    "blood-pressure": {
        title: "Blood Pressure – हाई बीपी के लक्षण और इलाज",
        image: "/images/blogs/7.jpg",
        content: {
            intro: `हाई ब्लड प्रेशर एक साइलेंट बीमारी है,
    जो बिना लक्षण के भी गंभीर नुकसान पहुँचा सकती है।`,

            nutrition: [
                "नमक कम करें",
                "हरी सब्ज़ियाँ और फल",
                "तला-भुना कम खाएँ",
            ],

            vaccination: `संक्रमण से बचाव के लिए
    समय-समय पर टीकाकरण सहायक होता है।`,

            mental: `तनाव हाई बीपी का बड़ा कारण है,
    इसलिए मानसिक शांति बहुत जरूरी है।`,

            checkup: [
                "नियमित बीपी जांच",
                "कोलेस्ट्रॉल जांच",
                "हार्ट जांच",
            ],

            prevention: [
                "नियमित वॉक",
                "धूम्रपान से दूरी",
                "वजन नियंत्रण",
            ],
        },
    },
    "healthy-diet": {
        title: "Healthy Diet – संतुलित आहार क्यों जरूरी है",
        image: "/images/blogs/8.jpg",
        content: {
            intro: `संतुलित आहार स्वस्थ जीवन की कुंजी है।
    सही भोजन से शरीर को ऊर्जा और रोगों से लड़ने की शक्ति मिलती है।`,

            nutrition: [
                "फल और सब्ज़ियाँ",
                "प्रोटीन – दाल, दूध, अंडा",
                "पर्याप्त पानी",
            ],

            vaccination: `स्वस्थ शरीर में टीकों का प्रभाव भी बेहतर होता है।`,

            mental: `अच्छा भोजन मानसिक स्वास्थ्य को भी बेहतर बनाता है।`,

            checkup: [
                "वजन निगरानी",
                "ब्लड शुगर",
                "कोलेस्ट्रॉल",
            ],

            prevention: [
                "जंक फूड से दूरी",
                "नियमित भोजन समय",
                "अत्यधिक चीनी से बचें",
            ],
        },
    },
    "seasonal-diseases": {
        title: "Seasonal Diseases – मौसमी बीमारियों से बचाव",
        image: "/images/blogs/9.jpg",
        content: {
            intro: `मौसम बदलने पर सर्दी, खांसी, बुखार जैसी
    बीमारियाँ आम हो जाती हैं।`,

            nutrition: [
                "गर्म और ताजा भोजन",
                "इम्युनिटी बढ़ाने वाले फल",
                "पर्याप्त पानी",
            ],

            vaccination: `मौसमी बीमारियों से बचाव के लिए
    टीकाकरण सहायक हो सकता है।`,

            mental: `बीमारी के समय आराम और सकारात्मक सोच जरूरी है।`,

            checkup: [
                "बुखार की जांच",
                "डॉक्टर से परामर्श",
            ],

            prevention: [
                "स्वच्छता",
                "हाथ धोने की आदत",
                "भीड़ से बचाव",
            ],
        },
    },
    "emergency-care": {
        title: "Emergency Care – आपातकाल में क्या करें",
        image: "/images/blogs/10.jpg",
        content: {
            intro: `आपात स्थिति में समय पर सही कदम
    मरीज की जान बचा सकता है।`,

            nutrition: [
                "बेहोशी में कुछ न खिलाएँ",
            ],

            vaccination: `आपात स्थिति से पहले
    सभी जरूरी टीके लगे होना फायदेमंद है।`,

            mental: `घबराने के बजाय शांत रहना सबसे जरूरी है।`,

            checkup: [
                "तुरंत डॉक्टर से संपर्क",
                "नजदीकी अस्पताल पहुँचें",
            ],

            prevention: [
                "आपात नंबर याद रखें",
                "फर्स्ट एड की जानकारी रखें",
            ],

        },
    },

};

function BlogDetail() {
    const { slug } = useParams();
    const blog = blogData[slug];

    if (!blog) {
        return (
            <div className="py-24 text-center">
                <h2 className="text-2xl font-bold text-gray-700">Blog not found</h2>
            </div>
        );
    }

    return (
        <section className="pt-24 pb-16 px-4 bg-gradient-to-r from-blue-600 to-indigo-600">
            <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden">

                {/* TITLE */}
                <div className="p-8 border-b">
                    <h1 className="text-3xl md:text-4xl font-bold text-blue-900">
                        {blog.title}
                    </h1>
                </div>

                {/* IMAGE */}
                <div className="w-full bg-gray-100 flex justify-center">
                    <img
                        src={blog.image}
                        alt={blog.title}
                        className="w-full h-auto max-h-[420px] object-contain"
                    />
                </div>

                {/* LEFT + RIGHT LAYOUT */}
                <div className="p-6 md:p-10">
                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">

                        {/* LEFT: TABLE OF CONTENTS */}
                        <aside className="hidden lg:block sticky top-28 h-fit">
                            <div className="bg-slate-50 rounded-xl shadow p-5 border-l-4 border-blue-600">
                                <h3 className="text-lg font-bold text-blue-800 mb-4">
                                    Table of Contents
                                </h3>
                                <ul className="space-y-2 text-sm">
                                    <li><a href="#intro" className="hover:text-blue-600">🧒 परिचय</a></li>
                                    <li><a href="#nutrition" className="hover:text-blue-600">🥗 सही पोषण</a></li>
                                    <li><a href="#vaccination" className="hover:text-blue-600">💉 टीकाकरण</a></li>
                                    <li><a href="#mental" className="hover:text-blue-600">🧠 मानसिक विकास</a></li>
                                    <li><a href="#checkup" className="hover:text-blue-600">🩺 स्वास्थ्य जांच</a></li>
                                    <li><a href="#prevention" className="hover:text-blue-600">🛡️ बचाव</a></li>
                                    <li><a href="#hospital" className="hover:text-blue-600">🏥 अस्पताल सेवाएं</a></li>
                                </ul>
                            </div>
                        </aside>

                        {/* RIGHT: CONTENT */}
                        <div className="lg:col-span-3">
                            <div className="bg-slate-50 rounded-2xl shadow-inner p-6 space-y-6">

                                <div id="intro" className="bg-white rounded-xl shadow p-6 border-l-4 border-blue-600">
                                    <p className="text-lg leading-relaxed">{blog.content.intro}</p>
                                </div>

                                <div id="nutrition" className="bg-blue-50 rounded-xl shadow p-6">
                                    <h2 className="text-xl font-bold text-blue-800 mb-3">
                                        सही पोषण (Balanced Nutrition)
                                    </h2>
                                    <ul className="list-disc ml-6 space-y-2">
                                        {blog.content.nutrition.map((item, i) => (
                                            <li key={i}>{item}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div id="vaccination" className="bg-white rounded-xl shadow p-6 border-l-4 border-green-600">
                                    <h2 className="text-xl font-bold text-green-700 mb-3">
                                        टीकाकरण (Vaccination)
                                    </h2>
                                    <p>{blog.content.vaccination}</p>
                                </div>

                                <div id="mental" className="bg-purple-50 rounded-xl shadow p-6">
                                    <h2 className="text-xl font-bold text-purple-800 mb-3">
                                        मानसिक और भावनात्मक विकास
                                    </h2>
                                    <p>{blog.content.mental}</p>
                                </div>

                                <div id="checkup" className="bg-white rounded-xl shadow p-6 border-l-4 border-orange-500">
                                    <h2 className="text-xl font-bold text-orange-700 mb-3">
                                        नियमित स्वास्थ्य जांच
                                    </h2>
                                    <ul className="list-disc ml-6 space-y-2">
                                        {blog.content.checkup.map((item, i) => (
                                            <li key={i}>{item}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div id="prevention" className="bg-red-50 rounded-xl shadow p-6">
                                    <h2 className="text-xl font-bold text-red-700 mb-3">
                                        बीमारियों से बचाव
                                    </h2>
                                    <ul className="list-disc ml-6 space-y-2">
                                        {blog.content.prevention.map((item, i) => (
                                            <li key={i}>{item}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div id="hospital" className="bg-blue-700 text-white rounded-xl shadow p-6">
                                    <h2 className="text-xl font-bold mb-2">
                                        Gavli Hospital Kurawar – संपूर्ण स्वास्थ्य सेवाएँ
                                    </h2>
                                    <p>
                                        Gavli Hospital एक आधुनिक एवं भरोसेमंद अस्पताल है, जहाँ अनुभवी
                                        डॉक्टरों की टीम द्वारा सभी आयु वर्ग के मरीजों को सुरक्षित, संवेदनशील
                                        एवं गुणवत्तापूर्ण चिकित्सा सेवाएँ प्रदान की जाती हैं। यहाँ आपातकालीन
                                        सेवाओं से लेकर जांच, उपचार, सर्जरी एवं निरंतर देखभाल तक की समस्त
                                        सुविधाएँ उपलब्ध हैं।
                                    </p>
                                </div>


                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default BlogDetail;
